import { render, staticRenderFns } from "./UserFans.vue?vue&type=template&id=1973ce02&"
import script from "./UserFans.vue?vue&type=script&lang=js&"
export * from "./UserFans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports